<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 17:20:22
 * @FilePath: \qctsw-vue\packages\app\src\pages\complaint\components\ComplaintColumnCollective.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER, provinceName } from '@qctsw/common'
import { getComplainTypeCode } from '../hooks/list'
import CollectiveItem from './CollectiveItem.vue'
import { logicComplaintColumnCollective } from '~/logic/complaint/column'
import { isOnlyRouteQueryKeyChange, useGetRouteQuery } from '~/shared/function'

const router = useRouter()

const page = useGetRouteQuery('page', '1')
const type = useGetRouteQuery('type', '0')
const sub = useGetRouteQuery('sub', '0')

const {
  state,
  list,
  pagination,
  getPage,
} = logicComplaintColumnCollective()

useActivatedWatch(() => [
  router?.afterEach((to, from) => {
    if (to.path !== from.path)
      return
    const isOnlyPageQueryChange = isOnlyRouteQueryKeyChange('page', to.query, from.query)

    if (!isOnlyPageQueryChange)
      pagination.initPagination()

    nextTick(() => {
      getPage(page.value, { complainTypeCode: getComplainTypeCode(type.value, sub.value) })
    })
  }),
])

await getPage(page.value, { complainTypeCode: getComplainTypeCode(type.value, sub.value) })

function getMore() {
  const pageNum = pagination.pagination.page + 1
  getPage(pageNum, { complainTypeCode: getComplainTypeCode(type.value, sub.value) })
}
</script>

<template>
  <div>
    <UtilLoadState :state="state" :length="list.length" type="up" :reload-handler="() => getPage(page, { complainTypeCode: getComplainTypeCode(type, sub) })">
      <baseList :state="state" @load="getMore">
        <template v-if="list.length">
          <div v-for="v, index in list" :key="index" class="py-sm">
            <CollectiveItem :item="v" />
          </div>
        </template>
      </baseList>
    </UtilLoadState>
    <!-- <BasicPagination
      v-if="pagination.pagination.pageCount > 1"
      class="mb-xl mt-xl max-w-100 mx-auto"
      :page="pagination.pagination.page"
      :total="pagination.pagination.pageCount"
      :to="(page) => APP_ROUTER.complaintList({ page, type, sub })"
    /> -->
  </div>
</template>

<style lang='scss' scoped>

</style>
